"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionRestrictionElement_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PermissionElementBehaviour_1 = require("./PermissionElementBehaviour");
var PermissionRestrictionElement_Factory = /** @class */ (function () {
    function PermissionRestrictionElement_Factory() {
    }
    PermissionRestrictionElement_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CsdElementTag: model.CsdElementTag,
            PermissionElementBehaviours: model.PermissionElementBehaviours && model.PermissionElementBehaviours.map(function (i) { return PermissionElementBehaviour_1.PermissionElementBehaviour_Factory.CreateIncoming(i); }),
            PermissionRestrictionElementId: model.PermissionRestrictionElementId,
        };
        return result;
    };
    PermissionRestrictionElement_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CsdElementTag: model.CsdElementTag,
            PermissionElementBehaviours: model.PermissionElementBehaviours && model.PermissionElementBehaviours.map(function (i) { return PermissionElementBehaviour_1.PermissionElementBehaviour_Factory.CreateOutgoing(i); }),
            PermissionRestrictionElementId: model.PermissionRestrictionElementId,
        };
        return result;
    };
    return PermissionRestrictionElement_Factory;
}());
exports.PermissionRestrictionElement_Factory = PermissionRestrictionElement_Factory;
